<template>
    <div class='component-page'>
       
        
        <!--下拉搜索位置-->
        <div class="edittable-table-height-con">
            <Row class='search-select'>
                <Col span="8">
                    <span>时间：</span>
                    <Date-picker type="date" placeholder="选择日期" v-model='start_time' style="width: 130px;display:inline-block" @on-change='changStarttime'></Date-picker>
                    <span style="margin: 0 10px;">至</span>
                    <Date-picker type="date" placeholder="选择日期" v-model='end_time' style="width: 130px;display:inline-block" @on-change='changEndtime'></Date-picker>
                </Col>
               
            </Row>
            <Table stripe border :columns="editIncellColumns" :data="editIncellData"></Table>
            <div style="margin: 20px 0 10px 0 ;overflow: hidden;">
                <Page style='float: right'  size="small" :total="total_count" :page-size="formItem.page_size" :current="formItem.page" @on-change="changePage" />
            </div>
        </div>
    
      
    </div>
</template>

<style lang="css">
    @import "../common.css";
</style>
<script>
    import {
        fetchTableList,
    } from '@/api/everydayStatistics.js'

    export default {
        name: 'user-components',
        data () {
            return {
                total_count: 0, //列表总条数
                formItem:{
                    page: 1, //列表当前页数
                    page_size: 10,
            
                    start_time: '',
                    end_time: '',
                   
                },
                start_time: '',
                end_time: '',
               
                editIncellColumns: [
                    {
                        title: '序号',
                        align: 'center',
                        type: 'index',
                        width: 80,
                    },
                    {
                        title: '校区ID',
                        align: 'center',
                        key: 'school_id',
                    },
                    {
                        title: '校区名称',
                        align: 'center',
                        key: 'school_name',

                    },
                    {
                        title: '数量',
                        align: 'center',
                        key: 'count',
                    },
                  
                  
                
                ],//列表
                editIncellData: [],//列表数据
            };
        },
        methods: {
            //获取列表数据
            getData () {
                this.$Loading.start();
                fetchTableList(this.formItem).then(res => {
                    res=res.data;
                    this.$Loading.finish();
                    if(res.code == 200){
                        this.editIncellData = res.data.list;
                        this.total_count = parseInt(res.data.total_count);
                    }else if(res.code == 14001){
                        this.$Message.error(res.msg);
                        this.$store.dispatch('handleLogOut').then(res => {
                            this.$store.commit('clearOpenedSubmenu')
                            this.$router.push({
                                name: 'login'
                            })
                        })
                    }else{
                        this.$Message.error(res.msg);
                    }
                })
            },
            seeInfo(id){

            },

             // 改变开始时间
            changStarttime(time) {
                if (time == '') {
                    this.formItem.start_time = '';
    
                } else {
                    this.formItem.start_time = new Date(time).getTime() / 1000 - 28800;
                }
                this.formItem.page = 1;
                this.getData();
            },
            // 改变结束时间
            changEndtime(time) {
                if (time == '') {
                    this.formItem.end_time = '';
    
                } else {
                    this.formItem.end_time = new Date(time).getTime() / 1000 + 57600;
                }
                this.formItem.page = 1;
                this.getData();
            },
            // 取消关闭弹层
            cancel(){
                this.addModel=false;
                this.detailsModal=false;
            },
           
            //搜索框搜索
            handleSearch () {
                this.formItem.page = 1;
                this.getData();
            },
            //改变当前页码
            changePage (row) {
                this.formItem.page = row;
                this.getData();
            },
            
        },
        created () {
            this.getData();
        }
    };
</script>
